import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login' // 默认路径重定向到登录页面
  },
  {
    path: '/login',
    name: 'homelogin',
    component: HomeView
  },
  {
    path: '/parq',
    name: 'parq',
    component: () => import('../views/parqView.vue'),
    meta: { requiresAuth: true } // 需要登录才能访问
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫：检查用户登录状态
router.beforeEach((to, from, next) => {
  // 获取URL查询参数
  const urlParams = new URLSearchParams(window.location.search)
  const institutionId = urlParams.get('institutionId')

  if (institutionId) {
    // 将 institutionId 保存到 store 中
    store.dispatch('global/setInstitutionId', institutionId)
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 检查是否已登录
    const isLoggedIn = store.getters['global/isLoggedIn']

    if (!isLoggedIn) {
      // 未登录，跳转到登录页
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
